/** Lo que devuelve `/api/v1/procesos`, y el vocabulario de los pasos. */

export type Paso = {
  id: number
  orden: number
  tipo: "INICIO" | "TAREA" | "DECISION" | "FIN"
  titulo: string
  descripcion: string | null
  responsable_cargo_id: number | null
  responsable: string | null
  rama_si: string | null
  rama_no: string | null
}

export type Proceso = {
  id: number
  nombre: string
  objetivo: string | null
  responsable_cargo_id: number | null
  responsable: string | null
  es_transversal: boolean
  activo: boolean
  pasos: Paso[]
  /** El área dueña y su procedimiento PRO de la Biblioteca, con sus nombres resueltos. */
  departamento_id: number | null
  departamento: string | null
  documento_id: number | null
  documento: string | null
}

export type CargoElegible = { id: number; nombre: string }

export const TIPOS = [
  ["INICIO", "Inicio"],
  ["TAREA", "Tarea"],
  ["DECISION", "Decisión"],
  ["FIN", "Fin"],
] as const

/** Los que NO son función de nadie: marcan dónde empieza y acaba el procedimiento. */
export const SIN_FUNCION = new Set(["INICIO", "FIN"])
